export default [
    '$translate', 'LogService',
    function ($translate, logService) {
        const log = logService.getLogger('VerificationLevel-C');
        return {
            restrict: 'EA',
            scope: {},
            bindToController: {
                contact: '=',
            },
            controllerAs: 'ctrl',
            controller: [function () {
                    this.$onInit = function () {
                        const contact = this.contact;
                        let label;
                        switch (contact.verificationLevel) {
                            case 1:
                                this.cls = 'level1';
                                label = 'VERIFICATION_LEVEL1_EXPLAIN';
                                break;
                            case 2:
                                this.cls = 'level2';
                                if (contact.isWork) {
                                    label = 'VERIFICATION_LEVEL2_WORK_EXPLAIN';
                                }
                                else {
                                    label = 'VERIFICATION_LEVEL2_EXPLAIN';
                                }
                                break;
                            case 3:
                                this.cls = 'level3';
                                label = 'VERIFICATION_LEVEL3_EXPLAIN';
                                break;
                            default:
                        }
                        if (label === undefined) {
                            log.error('invalid verification level', this.level);
                            return;
                        }
                        if (contact.isWork) {
                            this.cls += ' work';
                        }
                        this.description = $translate.instant('messenger.' + label);
                    };
                }],
            template: `
                <span class="verification-dots {{ctrl.cls}}" title="{{ctrl.description}}">
                    <div></div><div></div><div></div>
                </span>
            `,
        };
    },
];
